// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.x_panel {
  position: relative;
  width: 100%;
  margin-bottom: 10px;
  padding: 10px 17px;
  display: inline-block;
  background: #fff;
  border: 1px solid #e6e9ed;
  /* -webkit-column-break-inside: avoid;
  -moz-column-break-inside: avoid; */
  /* column-break-inside: avoid; */
  opacity: 1;
  transition: all 0.2s ease;
}
.x_content {
  padding: 0 5px 6px;
  position: relative;
  width: 100%;
  float: left;
  clear: both;
  margin-top: 5px;
}
.dataTables_wrapper {
  position: relative;
  clear: both;
  zoom: 1;
}
/* .dataTables_length {
  width: 40%;
  float: left;
} */
.form-horizontal .form-group {
  margin-right: 0;
  margin-left: 0;
}

.form-control {
  border-radius: 0;
  width: 100%;
}
.form-horizontal .form-group {
  margin-right: 0;
  margin-left: 0;
}
.form-control.has-feedback-left {
  padding-left: 45px;
}
.form-group.has-feedback span {
  display: block !important;
}
.input-group-text {
  background-color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/Sidebar/Zipcodes.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB;oCACkC;EAClC,gCAAgC;EAChC,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,WAAW;EACX,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;AACT;AACA;;;GAGG;AACH;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB","sourcesContent":[".x_panel {\r\n  position: relative;\r\n  width: 100%;\r\n  margin-bottom: 10px;\r\n  padding: 10px 17px;\r\n  display: inline-block;\r\n  background: #fff;\r\n  border: 1px solid #e6e9ed;\r\n  /* -webkit-column-break-inside: avoid;\r\n  -moz-column-break-inside: avoid; */\r\n  /* column-break-inside: avoid; */\r\n  opacity: 1;\r\n  transition: all 0.2s ease;\r\n}\r\n.x_content {\r\n  padding: 0 5px 6px;\r\n  position: relative;\r\n  width: 100%;\r\n  float: left;\r\n  clear: both;\r\n  margin-top: 5px;\r\n}\r\n.dataTables_wrapper {\r\n  position: relative;\r\n  clear: both;\r\n  zoom: 1;\r\n}\r\n/* .dataTables_length {\r\n  width: 40%;\r\n  float: left;\r\n} */\r\n.form-horizontal .form-group {\r\n  margin-right: 0;\r\n  margin-left: 0;\r\n}\r\n\r\n.form-control {\r\n  border-radius: 0;\r\n  width: 100%;\r\n}\r\n.form-horizontal .form-group {\r\n  margin-right: 0;\r\n  margin-left: 0;\r\n}\r\n.form-control.has-feedback-left {\r\n  padding-left: 45px;\r\n}\r\n.form-group.has-feedback span {\r\n  display: block !important;\r\n}\r\n.input-group-text {\r\n  background-color: #fff;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
